const switchClass = {
  path: 'switchClass',
  component: resolove => require(['../../../../components/pages/student_user/switchClass'], resolove)
}
export default switchClass
